<script lang="ts">
    import MainLayout from "../../#common/layout/Layout.svelte"
    import IconifyIcon from '@iconify/svelte'
    import eyeIcon from '@iconify/icons-fa-solid/eye'
    import editIcon from '@iconify/icons-fa-solid/pencil-alt'
    import copyIcon from '@iconify/icons-fa-solid/copy'
    import deleteIcon from '@iconify/icons-fa-solid/trash-alt'
    import clearIcon from '@iconify/icons-fa-solid/times'
    import codeIcon from '@iconify/icons-fa-solid/code'
    import arrowUpIcon from '@iconify/icons-fa-solid/sort-up'
    import arrowDownIcon from '@iconify/icons-fa-solid/sort-down'
    import Categories from 'src/components/cabinet/app-configs/components/Categories.svelte'
    import Modal from 'src/components/cabinet/#common/modal/Modal.svelte.ts'
    import CodeMirrorEditor from 'svelte-codemirror-editor'
    import { javascript } from '@codemirror/lang-javascript'
    import {Link} from 'svelte-routing'
    import {doShow as showAlert} from 'src/components/#common/alert/store'
    import type {ITreeListNode} from 'src/components/#common/tree-list/TreeListNode'
    import type {CategoryState} from 'src/components/cabinet/app-configs/components/contracts'
    import Variable from 'src/components/cabinet/app-configs/components/Variable.svelte'
    import {createConfig, getConfigById, updateConfig, deleteConfig, compareConfigs} from 'src/components/cabinet/#services/gameConfig'
    import {categoriesToObject, objectToCategories} from 'src/components/cabinet/app-configs/components/helpers'
    import {navigate} from 'src/global/navigate'
    import {Tooltip} from 'sveltestrap'

    export let id

    compareConfigs.reset()

    if (id) {
        getConfigById.reset()
        getConfigById.send({data: {id: +id}})
    }

    let config
    let searchText
    let categories
    let jsonCategories
    let jsonEditorStatus = false
    let jsonEditorValue
    let jsonIsValid = true

    $: searchText, selected = undefined

    $: jsonEditorValue, jsonValidation()

    $: if (!config && id && $getConfigById.hasValue) {
        config = $getConfigById.value && JSON.parse(JSON.stringify($getConfigById.value?.config))
        compareConfigs.send({ data: { key: config.key } })
        jsonCategories = JSON.parse(config.value)
        categories = objectToCategories({children: jsonCategories})
    } else if (!config && !id) {
        config = {
            name: '',
            key: '',
            value: []
        }
        jsonCategories = config.value
        categories = objectToCategories({children: jsonCategories})
    }

    let loading = false
    let categoryIsEdit = false
    let firstDraggable = false
    let showDeleteConfigModal = false
    let showDeleteCategoryModal = false

    let editableStates = new Map()

    // $: if (selected && selected.data && selected.data.data && selected.data.data.variables) {
    //     editableStates = selected.data.data.variables.map(() => false)
    // }

    let selected: ITreeListNode<CategoryState>
    // изменять selected только через эту функцию
    function setSelected(category: ITreeListNode<CategoryState>) {
        if (selected) {
            selected.data.selected = false
            selected.onChangeData()
        }
        selected = category
        if (selected) {
            selected.data.selected = true
            selected.onChangeData()
        }
        jsonEditorStatus = false
    }

    function deleteCategory() {
        showDeleteCategoryModal = false
        selected.deleteThis()
        selected = undefined
    }

    async function deleteConfigHandler() {
        showDeleteConfigModal = false

        try {
            await deleteConfig.request({ data: { id: +id } })

            showAlert.set({
                status: 'success',
                text: 'Config deleted successfully'
            })

            navigate('/app-configs')
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }

    function updatedCategory() {
        // вызывать эту функцию каждый раз поле изменения данных в category.data
        // TreeListNode не может автоматически отслеживать вложенных данных в category.data
        selected.onChangeData()
        categoryIsEdit = false
    }

    function jsonEditSwitch() {
        if (!jsonEditorStatus) {
            jsonEditorValue = JSON.stringify(selected.data.data.variables, null, 2)
        }
        jsonEditorStatus = !jsonEditorStatus
    }

    function jsonValidation() {
        if (selected) {
            try {
                jsonIsValid = !!JSON.parse(jsonEditorValue)
                selected.data.data.variables = JSON.parse(jsonEditorValue)
            } catch (error) {
                console.log('validation error')
                jsonIsValid = false
            }
        }
    }

    function getAvailableKey(arr) {
        let index = 0;
        while (arr.find((elem) => elem[0] === 'key' + index)) {
            index++;
        }
        return 'key' + index;
    }

    async function duplicateConfig() {
        try {
            let duplicate = config
            delete duplicate.id
            duplicate.name += ' copy'
            duplicate.key += '_copy'

            let newConfig = await createConfig.request({ data: duplicate })

            showAlert.set({
                status: 'success',
                text: 'Config duplicated successfully'
            })

            if (newConfig?.id) {
                id = newConfig?.id
                config = undefined
                getConfigById.reset()
                getConfigById.send({data: {id: +id}})
                navigate('/app-config/'+newConfig.id)
            } else {
                navigate('/app-configs')
            }
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }

    async function save() {
        try {
            loading = true

            let data = categoriesToObject(categories).children || []
            config.value = JSON.stringify(data)

            if (id) {
                await updateConfig.request({data: { id: +id, data: config }})

                compareConfigs.reset()
                compareConfigs.send({ data: { key: config.key } })

                showAlert.set({
                    status: 'success',
                    text: 'Config updated successfully'
                })
            } else {
                let newConfig = await createConfig.request({ data: config })

                showAlert.set({
                    status: 'success',
                    text: 'Config created successfully'
                })

                if (newConfig?.id) {
                    id = newConfig?.id
                    config = undefined
                    getConfigById.reset()
                    getConfigById.send({data: {id: +id}})
                    navigate('/app-config/'+newConfig.id)
                } else {
                    navigate('/app-configs')
                }
            }
        } catch (err) {
            console.error(err)
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            loading = false
        }
    }

    function sortArray(array, index1, index2) {
        let temp = array[index1]

        array[index1] = array[index2]
        array[index2] = temp

        selected.data.data.variables = array
        selected = selected
    }

    function initEditableState(index) {
        if (!editableStates.has(index)) {
            editableStates.set(index, false)
        }
    }
</script>

<svelte:head>
    {#if id}
        <title>Edit config</title>
    {:else}
        <title>Create config</title>
    {/if}
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <div class="row">
            <div class="col-12">
                <div class="card widget-flat mt-2">
                    <div class="card-body config-header">
                        <div class="input-group mb-2 buttons">
                            <Link to="app-configs" class="btn btn-primary">Back</Link>
                        </div>
                        <div class="input-group mb-2">
                            <span class="input-group-text">Name</span>
                            {#if config}
                                <input type="text" class="form-control" bind:value={config.name} placeholder="Enter name">
                            {:else}
                                <input type="text" class="form-control" value="Loading..." disabled>
                            {/if}
                        </div>
                        <div class="input-group mb-2">
                            <span class="input-group-text">Key</span>
                            {#if config}
                                <input type="text" class="form-control" bind:value={config.key} placeholder="config_key">
                            {:else}
                                <input type="text" class="form-control" value="Loading..." disabled>
                            {/if}
                        </div>
                        <div class="input-group mb-2">
                            <span class="input-group-text">Search</span>
                            <input type="text" class="form-control" bind:value={searchText} placeholder="Enter key..." class:filled={searchText}>
                            {#if searchText}
                                <span class="input-group-text search-btn" on:click={() => searchText = ''}>
                                    <IconifyIcon icon={clearIcon}/>
                                </span>
                            {/if}
                        </div>
                        {#if id}
                            <div class="input-group mb-2 buttons">
                                <button class="btn btn-secondary" on:click={duplicateConfig} title="Duplicate config" disabled={!config}>
                                    <IconifyIcon icon={copyIcon}/>
                                </button>
                            </div>
                            <div class="input-group mb-2 buttons">
                                <button class="btn btn-secondary" on:click={jsonEditSwitch} title="JSON editor" disabled={!config || !selected}>
                                    <IconifyIcon icon={codeIcon}/>
                                </button>
                            </div>
                            <div class="input-group mb-2 buttons">
                                <button class="btn btn-danger" on:click={() => showDeleteConfigModal = true} title="Delete config" disabled>
                                    <IconifyIcon icon={deleteIcon}/>
                                </button>
                            </div>
                        {/if}
                        {#if $compareConfigs.hasValue && $compareConfigs.value?.isEqual === false}
                            <div class="alert alert-danger configs-different">Configs are different!</div>
                        {/if}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xxl-3">
                <div class="categories">
                    {#if categories}
                        <Categories bind:firstDraggable bind:categories {searchText}
                            on:select={(event) => { setSelected(event.detail) }}
                        />
                    {/if}
                </div>
                <button class="btn btn-success w-100 mt-3 mb-3" class:loading={loading} on:click={save}
                    disabled={loading || !jsonIsValid || (id && !config) || (config && (!config.name || !config.key))}>
                    {#if id}Save changes{:else}Create config{/if}
                </button>
            </div>
            <div class="col-xxl-9">
                {#if !selected}
                    <div class="card widget-flat">
                        <div class="card-body category-header">Select or create category</div>
                    </div>
                {:else}
                    <div class="card widget-flat">
                        <div class="card-body category-header">
                            {#if !categoryIsEdit}
                                <h4 class="category-name">{selected.data.data.name || ''}</h4>
                            {:else}
                                <input type="text" class="form-control mb-2" bind:value="{selected.data.data.name}" placeholder="Title">
                            {/if}
                            {#if !categoryIsEdit}
                                <div class="category-description">{selected.data.data.description || ''}</div>
                            {:else}
                                <textarea class="form-control mb-2" bind:value={selected.data.data.description} placeholder="Description"></textarea>
                            {/if}
                            <div class="buttons">
                                {#if categoryIsEdit}
                                    <button class="btn btn-success" on:click={updatedCategory}>
                                        Apply
                                    </button>
                                    <button class="btn btn-secondary" on:click={() => categoryIsEdit = false}>
                                        Cancel
                                    </button>
                                {:else}
                                    <button class="btn btn-secondary" on:click={() => categoryIsEdit = true}>
                                        <IconifyIcon icon={editIcon}/>
                                    </button>
                                    <button class="btn btn-danger" on:click={() => showDeleteCategoryModal = true}>
                                        <IconifyIcon icon={deleteIcon}/>
                                    </button>
                                {/if}
                            </div>
                        </div>
                    </div>
                    <div class="card widget-flat">
                        {#if jsonEditorStatus}
                            {#if !jsonIsValid}<p class="alert alert-danger">JSON invalid</p>{/if}
                            <CodeMirrorEditor bind:value={jsonEditorValue} lang={javascript()} placeholder="Your code here..."/>
                        {:else}
                            <div class="card-body variables">
                                {#if selected.data.data.variables}
                                    {#each selected.data.data.variables as variable, index (variable)}
                                        {#if variable != null && typeof variable === 'object' && variable.type === 'object'}
                                            {#if !editableStates.has(index)}
                                                {@html initEditableState(index)}
                                            {/if}
                                            <div class="main-variable-group">
                                                <Tooltip target={`btn-tooltip-${index}`} placement="left">
                                                    {#if editableStates.get(index)}
                                                        Disable editable
                                                    {:else}
                                                        Enable editable
                                                    {/if}
                                                </Tooltip>
                                                <button class="btn editable-mode" id="btn-tooltip-{index}"
                                                    on:click={() => {
                                                        editableStates.set(index, !editableStates.get(index));
                                                        editableStates = new Map(editableStates);
                                                    }}>
                                                    {#if editableStates.get(index)}
                                                        <IconifyIcon icon={eyeIcon}/>
                                                    {:else}
                                                        <IconifyIcon icon={editIcon}/>
                                                    {/if}
                                                </button>
                                                {#each variable.value as entry, variableIndex (entry)}
                                                    <Variable
                                                        level={1}
                                                        {searchText}
                                                        readonly={!editableStates.get(index)}
                                                        bind:key={entry[0]}
                                                        bind:value={entry[1]}
                                                        on:delete={() => {
                                                            selected.data.data.variables[index].value.splice(variableIndex,1)
                                                            selected = selected
                                                        }}
                                                        on:changeType={() => {
                                                            selected = selected
                                                        }}
                                                    />
                                                {/each}
                                                {#if editableStates.get(index)}
                                                    <div class="row">
                                                        <div class="col-1">
                                                            <div class="sort-buttons">
                                                                <button on:click={() => {
                                                                    sortArray(selected.data.data.variables, index, index-1)
                                                                }} disabled={index === 0}>
                                                                    <IconifyIcon icon={arrowUpIcon}/>
                                                                </button>
                                                                <button on:click={() => {
                                                                    sortArray(selected.data.data.variables, index, index+1)
                                                                }} disabled={index === selected.data.data.variables.length-1}>
                                                                    <IconifyIcon icon={arrowDownIcon}/>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="col-5 pl-0">
                                                            <button class="btn btn-success variable-btn w-100" on:click={() => {
                                                                variable.value.push([getAvailableKey(variable.value), {
                                                                    type: 'string',
                                                                    description: '',
                                                                    value: ''
                                                                }])
                                                                variable = variable
                                                            }}>Add variable</button>
                                                        </div>
                                                        <div class="col-3 pl-0">
                                                            <button class="btn btn-success copy-group-btn w-100" on:click={() => {
                                                                selected.data.data.variables.push(
                                                                    JSON.parse(JSON.stringify(selected.data.data.variables[index]))
                                                                )
                                                                selected = selected
                                                                editableStates.set(selected.data.data.variables.length-1, true);
                                                                editableStates = new Map(editableStates)
                                                            }}>Copy group</button>
                                                        </div>
                                                        <div class="col-3 pl-0">
                                                            <button class="btn btn-danger w-100" on:click={() => {
                                                                selected.data.data.variables.splice(index, 1)
                                                                selected = selected
                                                            }}>Delete group</button>
                                                        </div>
                                                    </div>
                                                {/if}
                                            </div>
                                        {/if}
                                    {/each}
                                    <button class="btn btn-success w-100" on:click={() => {
                                        selected.data.data.variables.push({
                                            type: 'object',
                                            value: [],
                                        })
                                        selected = selected
                                        editableStates.set(selected.data.data.variables.length-1, true)
                                        editableStates = new Map(editableStates)
                                    }}>Add group</button>
                                {:else}
                                    <div class="row">
                                        <div class="col-12">
                                            <button class="btn btn-success w-100" on:click={() => {
                                                if (!selected.data.data.variables) {
                                                    selected.data.data.variables = []
                                                }
                                                selected.data.data.variables.push({
                                                    type: 'object',
                                                    value: []
                                                })
                                                selected = selected
                                                editableStates.set(selected.data.data.variables.length-1, true)
                                                editableStates = new Map(editableStates)
                                            }}>Add group</button>
                                        </div>
                                    </div>
                                {/if}
                            </div>
                        {/if}
                    </div>
                {/if}
            </div>
        </div>
        <Modal bind:visible={showDeleteCategoryModal}>
            <svelte:fragment slot="content">
                <div class="modal-custom__title">Delete category</div>
                <div class="modal-custom__text">
                    {#if !selected}
                        Loading...
                    {:else}
                        Are you sure you want to delete <strong>{selected.data.data.name}</strong> category?
                    {/if}
                </div>
                <div class="modal-custom__footer">
                    <button class="btn btn-cancel" on:click={() => { showDeleteCategoryModal = false }}>Close</button>
                    <button class="btn btn-primary" on:click={deleteCategory}>Confirm</button>
                </div>
            </svelte:fragment>
        </Modal>
        <Modal bind:visible={showDeleteConfigModal}>
            <svelte:fragment slot="content">
                <div class="modal-custom__title">Delete game config</div>
                <div class="modal-custom__text">
                    Are you sure you want to delete this game config?
                </div>
                <div class="modal-custom__footer">
                    <button class="btn btn-cancel" on:click={() => { showDeleteConfigModal = false }}>Close</button>
                    <button class="btn btn-primary" on:click={deleteConfigHandler}>Confirm</button>
                </div>
            </svelte:fragment>
        </Modal>
    </svelte:fragment>
</MainLayout>

<style lang="postcss">
    @import "../../../../styles/global/scrollbar.pcss";

    .categories {
        max-height: calc(100vh - 284px);
        min-height: 250px;
        overflow: auto;
        box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);
        background: white;
        border-radius: 0.25rem;
        @include scrollbar;
        @include scroll-smooth;
    }

    :global(.alerts + .row + .row .categories) {
        max-height: calc(100vh - 343px);
    }

    .main-variable-group .editable-mode {
        position: absolute;
        display: none;
        left: -28px;
        top: -1px;
        bottom: -1px;
        width: 30px;
        height: calc(100% + 2px);
        align-items: flex-start;
        justify-content: center;
        background: #f6f7fa;
        border: 1px solid #ced4da;
        border-right: 0;
        padding: 8px 0 0 !important;
        margin: 0;
        border-radius: 5px 0 0 5px;
        transition: .2s;
        color: #41474d;
        cursor: pointer;
        outline: none;
        box-shadow: none;
    }

    .main-variable-group:hover .editable-mode {
        display: flex;
    }

    .main-variable-group:hover .editable-mode:hover {
        background: #ced4da;
    }

    .category-description {
        margin-bottom: 10px;
    }

    .form-control {
        max-width: 350px;
    }

    .main-variable-group {
        padding: 5px;
        border: 1px solid #ced4da;
        margin-bottom: 5px;
        border-radius: 5px;
        background: #f6f7fa;
        max-width: 500px;
        position: relative;
    }

    .buttons button {
        padding: 6px 10px !important;
        font-size: 14px;
        border: 0;
    }

    .config-header {
        display: flex;
    }

    .config-header .input-group {
        width: auto;
        margin-right: 15px;
    }

    .input-group.buttons .btn {
        min-width: 41px;
    }

    .configs-different {
        padding: 10px 12px;
        line-height: normal;
        margin-bottom: 0.5rem !important;
    }

    .btn.btn-success.variable-btn {
        background: #3eaea5;
    }

    .btn.btn-success.variable-btn:hover {
        background: #39a59c;
    }

    .btn.btn-success.copy-group-btn {
        background: #8391a2;
    }

    .btn.btn-success.copy-group-btn:hover {
        background: #7b8899;
    }

    .pl-0 {
        padding-left: 0;
    }

    .form-control.filled {
        background: rgba(255, 235, 59, 0.3);
    }

    .search-btn {
        cursor: pointer;
    }

    .form-control:focus {
        box-shadow: none;
    }

    .sort-buttons {
        width: 100%;
        height: 100%;
    }

    .sort-buttons button {
        width: 100%;
        height: calc(50% - 2px);
        padding: 0;
        border: 0;
        display: flex;
        justify-content: center;
        background: #ced4da;
        border-radius: 0.25rem;
        transition: .25s;
        cursor: pointer;
        color: #636f7e;
    }

    .sort-buttons button:hover {
        background: #b8c0c9;
        color: #515c6a;
    }

    .sort-buttons button[disabled] {
        background: #e3e7eb;
        color: #b2bcc7;
        cursor: default;
    }

    .sort-buttons :global(button:first-child svg) {
        margin-bottom: -6px;
    }

    .sort-buttons :global(button:last-child svg) {
        margin-top: -6px;
    }

    .sort-buttons button:first-child {
        align-items: end;
        margin-bottom: 4px;
    }

    .sort-buttons button:last-child {
        align-items: start;
        margin-top: 4px;
    }

    @media(max-width: 991px) {
        .config-header {
            flex-wrap: wrap;
        }

        .categories {
            max-height: 300px;
        }
    }
</style>
